import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import MasterServices from '../../../../../services/master'
import useDebounce from '../../../../../utils/hooks/useDebounce'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
}

const Forms: React.FC<Props> = ({toggle, getData, editFormValue}) => {
  const [isEdit, setIsEdit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [counter, setCounter] = useState<any>(0)
  const [disabled, setDisabled] = useState(false)
  const [certificate, setCertificate] = useState<any>(null)
  const [transcript, setTranscript] = useState<any>(null)
  const [formValue, setFormValue] = useState<any>({
    universities: '',
    degrees: '',
    majors: '',
    start_date: '',
    end_date: '',
    gpa: '',
    description: '',
  })
  const [inputs, setInputs] = useState([
    {
      name: 'universities',
      label: 'Institusi Pendidikan',
      type: 'select-creatable',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      counter: 1,
      child: [],
      getItemValue: 'universities_name',
      items: [],
    },
    {
      name: 'degrees',
      label: 'Jenjang Pendidikan',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      counter: 1,
      child: [],
      getItemValue: 'degrees_name',
      getItemValueId: 'degrees_id',
      items: [],
    },
    {
      name: 'majors',
      label: 'Jurusan',
      type: 'select-creatable',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      counter: 1,
      child: [],
      getItemValue: 'majors_name',
      getItemValueId: 'majors_id',
      items: [],
    },
    {
      name: 'start_date',
      label: 'Tahun Masuk',
      type: 'date',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      counter: 1,
      child: [],
      getItemValue: null,
      items: [],
    },
    {
      name: 'end_date',
      label: 'Tahun Lulus',
      type: 'date',
      validation: {},
      col: 6,
      disabled: false,
      options: [],
      child: [
        {
          name: 'end_date_to_disabled',
          label: 'Sedang dalam masa studi',
          type: 'date',
          validation: {},
          col: 6,
          options: [],
          additional: '',
          counter: 1,
          child: [],
          getItemValue: null,
          items: [],
        },
      ],
      additional: '',
      counter: 1,
    },
    {
      name: 'gpa',
      label: 'Nilai (Opsional)',
      type: 'number',
      validation: {},
      col: 3,
      options: [],
      additional: '',
      counter: 1,
      child: [],
      getItemValue: null,
      items: [],
    },
    {
      name: 'gpa_max',
      label: 'Standar Nilai (Opsional)',
      type: 'number',
      validation: {},
      col: 3,
      options: [],
      additional: '',
      counter: 1,
      child: [],
      getItemValue: null,
      items: [],
    },
    {
      name: 'description',
      label: 'Deskripsi (Opsional)',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      counter: 1,
      child: [],
      getItemValue: null,
      items: [],
    },
  ])

  useEffect(() => {
    setFormValue(editFormValue)
    setIsEdit(!isEdit)
    if (!editFormValue.end_date) {
      disableUpload(!inputs[4].disabled)
    }
  }, [editFormValue])

  useDebounce(
    () => {
      getUniversities(isEdit ? '' : formValue.universities)
    },
    250,
    [formValue.universities]
  )

  useDebounce(
    () => {
      getDegrees(isEdit ? '' : formValue.degrees)
    },
    250,
    [formValue.degrees]
  )

  useDebounce(
    () => {
      getMajors(isEdit ? '' : formValue.majors)
    },
    250,
    [formValue.majors]
  )

  const disableUpload = (value: boolean) => {
    let cloneForms = inputs
    cloneForms[4].disabled = value
    setInputs(cloneForms)
    setDisabled(value)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    if (name === 'end_date_to_disabled') {
      setFormValue({
        ...formValue,
        end_date: null,
      })
      disableUpload(!inputs[4].disabled)
      return
    }

    if (name === 'certificate') {
      setCertificate(e.target.files[0])
      return
    }

    if (name === 'transcript') {
      setTranscript(e.target.files[0])
      return
    }

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const onSelect = (input: any, row: any, key: any) => {
    const name = input

    switch (name) {
      case 'universities':
        getUniversities(row)
        break
      case 'majors':
        getMajors(row)
        break
    }
  }

  const uploadCertificate = async (id?: any) => {
    setLoading(true)
    await UserService.uploadFileEducationCertificate({file: certificate}, id)
      .then((response) => {
        setLoading(false)
        toggle()
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const uploadTranscript = async (id?: any) => {
    setLoading(true)
    await UserService.uploadFileEducationTranscript({file: transcript}, id)
      .then((response) => {
        setLoading(false)
        toggle()
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const handleSubmit = async (e: any) => {
    e?.preventDefault()
    const formData = new FormData(e.target)

    let formProps = Object.fromEntries(formData)
    formProps = {
      ...formProps,
      universities: formValue.universities?.value ?? formValue.universities,
      degrees: formValue.degrees?.degrees_name ?? formValue.degrees,
      majors: formValue.majors?.value ?? formValue.majors,
    }

    setLoading(true)
    await UserService.createOrUpdateEducation(formProps, editFormValue.user_educations_id)
      .then(async (response) => {
        let id = editFormValue?.rowDetail?.user_educations_id ?? response.data?.user_educations_id

        if (certificate && transcript) {
          uploadCertificate(id)
          uploadTranscript(id)
          getData()
          await toast.success(`Pendidikan berhasil ${id ? 'diperbarui' : 'dibuat'}`)
          return
        }

        if (certificate) {
          uploadCertificate(id)
          getData()
          await toast.success(`Pendidikan berhasil ${id ? 'diperbarui' : 'dibuat'}`)
          return
        }

        if (transcript) {
          uploadTranscript(id)
          getData()
          await toast.success(`Pendidikan berhasil ${id ? 'diperbarui' : 'dibuat'}`)
          return
        }

        toggle()
        getData()
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const getUniversities = async (q: any) => {
    try {
      setLoading(true)
      const {data} = await MasterServices.getUniversities({...{is_active: 1}, q})
      let clone = inputs
      clone[0].items = data.data
      clone[0].options = data.data
      setInputs(clone)
      setCounter((val: any) => (val += 1))
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const getDegrees = async (q: any) => {
    try {
      const {data} = await MasterServices.getDegree({...{is_active: 1}, q})
      let clone = inputs
      clone[1].items = data.data
      clone[1].options = data.data
      setInputs(clone)
      setCounter((val: any) => (val += 1))
    } catch (error) {
    }
  }

  const getMajors = async (q: any) => {
    try {
      const {data} = await MasterServices.getMajor({...{is_active: 1}, q})
      let clone = inputs
      clone[2].items = data.data
      clone[2].options = data.data

      setInputs(clone)
      setCounter((val: any) => (val += 1))
    } catch (error) {
    }
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>
          {FormGenerator(inputs, formValue, onChange, onSelect, loading)}
          <Col md={12}>
            <Row className='d-grid gap-4'>
              <Col md={12}>
                <Form.Label>Unggah Dokumen Ijazah (Opsional)</Form.Label>
              </Col>
              <Col md={12}>
                <input type='file' name='certificate' disabled={disabled} onChange={onChange} />
              </Col>
              {formValue?.rowDetail?.certificate_url_full &&
              formValue?.rowDetail?.certificate_url_full ? (
                <Col md={12}>
                  <a href={formValue?.rowDetail?.certificate_url_full} target='_blank'>
                    Ijazah {formValue?.universities}
                  </a>
                </Col>
              ) : null}
              <Col md={12}>
                <Form.Text>pdf Max file size is 2MB</Form.Text>
              </Col>
            </Row>
          </Col>
          <Col md={12} className='mt-6'>
            <Row className='d-grid gap-4'>
              <Col md={12}>
                <Form.Label>Unggah Dokumen Transkrip Nilai (Opsional)</Form.Label>
              </Col>
              <Col md={12}>
                <input type='file' name='transcript' disabled={disabled} onChange={onChange} />
              </Col>
              {formValue?.rowDetail?.transcript_url_full ? (
                <Col md={12}>
                  <a
                    href={
                      formValue?.rowDetail?.transcript_url_full &&
                      formValue?.rowDetail?.transcript_url_full
                    }
                    target='_blank'
                  >
                    Transkrip Nilai {formValue?.universities}
                  </a>
                </Col>
              ) : null}
              <Col md={12}>
                <Form.Text>pdf Max file size is 2MB</Form.Text>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={loading}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={loading}>
            {loading ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default Forms
